"use client";

import { useEffect, useRef, useState } from "react";
import { ADSENSE_CLIENT_ID } from "@/data/adConfig";

interface GoogleAdProps {
	adSlot: string;
	adFormat?: string;
	fullWidthResponsive?: boolean;
	style?: React.CSSProperties;
	className?: string;
}

declare global {
	interface Window {
		adsbygoogle?: unknown[];
	}
}

export default function GoogleAd({ adSlot, adFormat = "auto", fullWidthResponsive = true, style, className }: GoogleAdProps) {
	const adRef = useRef<HTMLModElement>(null);
	const pushed = useRef(false);
	const [isLocal, setIsLocal] = useState(false);

	useEffect(() => {
		const local = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
		setIsLocal(local);

		if (!ADSENSE_CLIENT_ID || pushed.current || local) return;
		try {
			(window.adsbygoogle = window.adsbygoogle || []).push({});
			pushed.current = true;
		} catch {
			// AdSense not loaded
		}
	}, []);

	if (!ADSENSE_CLIENT_ID) return null;

	if (isLocal) {
		return (
			<div
				className={className}
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: "100%",
					background: "repeating-linear-gradient(45deg, #e5e7eb, #e5e7eb 10px, #f3f4f6 10px, #f3f4f6 20px)",
					border: "1px dashed #9ca3af",
					borderRadius: 6,
					color: "#6b7280",
					fontSize: 13,
					fontWeight: 500,
					...style,
				}}
			>
				AD {style?.maxWidth ? `${style.maxWidth} × ${style.height}` : adFormat || "auto"}
			</div>
		);
	}

	return (
		<ins
			ref={adRef}
			className={`adsbygoogle ${className ?? ""}`}
			style={{ display: "block", width: "100%", ...style }}
			data-ad-client={ADSENSE_CLIENT_ID}
			data-ad-slot={adSlot}
			data-ad-format={adFormat}
			{...(fullWidthResponsive ? { "data-full-width-responsive": "true" } : {})}
		/>
	);
}
